<template>
  <div>
    <slot :click="openModal">
      <v-btn @click="openModal">Add New Special Offer</v-btn>
    </slot>
    <v-dialog v-if="showDialog" v-model="showDialog" max-width="500px" persistent>
      <v-card class="pa-4">
        <v-card-title class="px-4">
            <h2 class="title">Add New Special Offer</h2>
        </v-card-title>
        <div class="py-4 px-6">
          <v-flex class="px-1">
            <v-text-field
              label="Offer Text"
              v-model="preparedData.name"
              placeholder="Please Enter"
              :error-messages="errors($v.preparedData.name || server_errors.name)"
              @blur="$v.preparedData.name.$touch()"
              @focus="resetServerValidation"
            >
            </v-text-field>
          </v-flex>
          <v-flex class="px-1">
            <v-text-field
              label="Coupon Code"
              v-model="preparedData.coupon_id"
              placeholder="Please Enter"
              :error-messages="errors($v.preparedData.coupon_id || server_errors.coupon_id)"
              @blur="$v.preparedData.coupon_id.$touch()"
              @focus="resetServerValidation"
            >
            </v-text-field>
          </v-flex>
          <v-flex class="px-1">
            <v-text-field
              label="Disclaimer"
              v-model="preparedData.disclaimer"
              placeholder="Please Enter"
              :error-messages="errors($v.preparedData.disclaimer || server_errors.disclaimer)"
              @blur="$v.preparedData.disclaimer.$touch()"
              @focus="resetServerValidation"
            >
            </v-text-field>
          </v-flex>
          <v-alert 
            class="pa-2 mt-4"
            :value="$v.$error"
            outlined
            color="error"
            icon="priority_high"
            transition="scale-transition"
          >
            <span class="caption">Please fill out form correctly</span>    
          </v-alert>
          <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
            <span class="caption">{{ serverValidationMessage }}</span>
          </v-alert>
        </div>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
            <v-btn color="primary" :loading="saveLoading" :disabled="saveLoading" @click="saveChanges">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EventBus from "@/main"
import ApiService from "@/common/api.service"
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
import { valMessages, getValMessage } from "@/common/error-messages"

const validations = {
  preparedData: {
    name: { required },
    coupon_id: {},
    disclaimer: {}
  }
}

export default {
  name: 'AddSpecialOffer',
  mixins: [validationMixin],
  validations,
  data() {
    return {
      no_data: [null, "", undefined, "null"],
      preparedData: {},
      saveLoading: false,
      showDialog: false,
      serverValidation: true,
      serverValidationMessage: "Oops something went wrong...",
      server_errors: {}
    }
  },
  methods: {
    openModal() {
      this.showDialog = true
      this.saveLoading = false
      this.preparedData = {
        business_name: this.businessName
      }
      this.resetServerValidation();
      this.$v.$reset()
    },
    saveChanges() {
      this.resetServerValidation()
      this.$v.$touch()

      if(!this.$v.$invalid){
        let body = _.cloneDeep(this.preparedData)
        this.saveLoading = true;

        ApiService.post("/gotpooperscoopers/coupon", body)
          .then(response => {
            this.saveLoading = false;
            EventBus.$emit("notification", {
              status: "success",
              text: "New Special Offer has been successfully added."
            });
            this.$emit('done')
            this.closeModal()
          })
          .catch(({ response }) => {
            this.saveLoading = false;
            this.serverValidation = false;
            if (response.data.error) {
              this.serverValidationMessage = this.titleCase(response.data.error);
            }
            if (response.data.message) {
              this.serverValidationMessage = response.data.message;
            }
            if (response.data.errors) {
              if (typeof response.data.errors === "string") {
                this.serverValidationMessage = response.data.errors;
              } else {
                this.server_errors = response.data.errors;
              }
            }
          });
      }
    },
    closeModal() {
      this.showDialog = false
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
      this.server_errors = {};
    },
    errors: getValMessage(valMessages)(validations)
  },
}
</script>